import ListarObligaciones from './ListarObligaciones'
import RegistrarObligaciones from './RegistrarObligaciones'

const ObligacionesContractuales = () => {
  return (
    <div>

        <RegistrarObligaciones/>
        <ListarObligaciones/>

    </div>
  )
}

export default ObligacionesContractuales